import styled, { css } from "styled-components";

export const LoadInfoStyled = styled.div`
  .input {
    padding: 7px 12px;
    border-radius: 8px;
    background-color: #ffffff;
    width: 100%;
    font-weight: bold;
  }

  .down-arrow {
    position: absolute;
    left: 12px;
    top: 0px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .text-area {
    border: none;
    width: 100%;
    max-height: 48px;
    border-radius: 8px;
    margin-top: 12px;
    padding: 6px 12px;
    font-size: 0.9em;
    ${({ dark }) =>
      dark &&
      css`
        background-color: #eaebed;
      `}
  }

  .react-select {
    & > div {
      border-radius: 8px;
      ${({ dark }) =>
        dark &&
        css`
          background-color: #eaebed;
        `} & > div:first-child {
        border: none;
      }
    }

    .css-1okebmr-indicatorSeparator {
      display: none;
    }
  }
`;
